import React from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../services/authService';

const ProtectedRoute = ({ children, section }) => {
  const isAuthenticated = authService.isAuthenticated();
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // Если указан раздел, проверяем доступ к нему
  if (section && !authService.hasAccess(section)) {
    return (
      <div className="container">
        <div className="card mt-3">
          <h2>Access Denied</h2>
          <p>You don't have access to this section. Please contact your administrator.</p>
          <p><a href="/">Return to Home</a></p>
        </div>
      </div>
    );
  }
  
  return children;
};

export default ProtectedRoute;